import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UnidadEjecutoraSigepService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getUnidadEjecutoraSigep(): Observable<any> {
    return this.http.get(this.baseUrl + 'parUnidadEjecutoraSigep', { headers: this.header(this.token) });
  }

  getUnidadEjecutoraSigepActivo(): Observable<any> {
    return this.http.get(this.baseUrl + 'parUnidadEjecutoraSigepActivos', { headers: this.header(this.token) });
  }
  
  getUnidadEjecutoraSigepById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parUnidadEjecutoraSigep/' + id, { headers: this.header(this.token) });
  }

  postUnidadEjecutoraSigep(UnidadEjecutoraSigep: any): Observable<any> {
    return this.http.post(this.baseUrl + 'parUnidadEjecutoraSigep', UnidadEjecutoraSigep, { headers: this.header(this.token) });
  }

  putUnidadEjecutoraSigep(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parUnidadEjecutoraSigep', bodyString, { headers: this.header(this.token) });
  }

  deleteUnidadEjecutoraSigep(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parUnidadEjecutoraSigep/' + id, { headers: this.header(this.token) });
  }
  
}